import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { EntityRenewalService } from '../entity-renewal.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { OfficeSelectableListModel } from '../../../model/officeSelectableListModel';
import { SelectInactiveOfficesToRenewRequestModel } from '../../../model/selectInactiveOfficesToRenewRequestModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { MessageModel } from '../../../model/messageModel';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { IndividualLicenseService } from '../../../broker/view-pending-approvals/individual-license.service';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { WorkflowStepModel } from '../../../model/workflowStepModel';


@Component({
  selector: 'app-inactive-offices-entity-renewal',
  templateUrl: './inactive-offices-entity-renewal.component.html',
  styleUrls: ['./inactive-offices-entity-renewal.component.css']
})
export class InactiveOfficesEntityRenewalComponent implements OnInit, OnDestroy {
  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  officeList: Array<OfficeSelectableListModel> = [];
  userMessages: Array<MessageModel> = [];
  selectedAll: any;
  inactiveOfficesToRenewRequest: SelectInactiveOfficesToRenewRequestModel = new SelectInactiveOfficesToRenewRequestModel();

  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  individualCorporationStatusResponse: SubmitIndividualCorporationStatusResponseModel = new SubmitIndividualCorporationStatusResponseModel();
  notifyQuestionListSubscription = new Subscription();
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];

  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  submitQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();

  constructor(private entityRenewalService: EntityRenewalService,
    private individualRenewalService: IndividualRenewalService,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,
    private spinner: SpinnerService,
    private router: Router) {

    this.notifyIndividualCorporationStatusResponseSubscription = this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
      (data: SubmitIndividualCorporationStatusResponseModel) => {
        this.individualCorporationStatusResponse = data;
      }
    );
    this.notifyQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
      this.individualRenewalQuestions = questionListData;
    });

    this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
    });
  }

  ngOnInit() {

    this.startFunction = this.storage.getStartFunctionData();

    if (this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel == null) {
      this.workflow = this.startFunction.Workflow;
    }
    else {
      this.workflow = this.entityRenewalService.renewalWorkflowModel;

    }

    // if(this.submitQuestionnaireAnswersResponseModel.Workflow!=null && this.individualCorporationStatusResponse.Workflow==null){
    //   this.workflow = this.submitQuestionnaireAnswersResponseModel.Workflow;
    // }
    // if(this.individualCorporationStatusResponse.Workflow!=null){
    //   this.workflow = this.individualCorporationStatusResponse.Workflow;
    // }
    // if(this.submitQuestionnaireAnswersResponseModel.Workflow==null && this.individualCorporationStatusResponse.Workflow==null){
    //   this.workflow = this.startFunction.Workflow;
    // }

    this.entityRenewalService.getInactiveOffices(this.workflow.WorkflowID).subscribe(
      (resp: OfficeSelectableListModel[]) => {
        console.log("selectableList ", resp);
        resp.forEach(element => {
          this.officeList.push(element);
          this.spinner.hide();
        });


      })
  }


  continue() {
    this.currentPageWatcher.clearUserMessage();
    console.log("CurrentStepIndex == ", this.workflow.CurrentStepIndex);
    //this should be 1 but it is 0 from start function in the storage
    // if(this.individualCorporationStatusResponse==null){
    //   this.inactiveOfficesToRenewRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;
    //   this.inactiveOfficesToRenewRequest.WorkflowID = this.workflow.WorkflowID;
    // }
    // else{
    this.inactiveOfficesToRenewRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;
    this.inactiveOfficesToRenewRequest.WorkflowID = this.workflow.WorkflowID;
    // }
    this.inactiveOfficesToRenewRequest.EntityID = this.officeList.filter(element => element.selected).map(element => element.EntityID);

    this.entityRenewalService.submitInactiveOffices(this.inactiveOfficesToRenewRequest).subscribe(
      (resp: SelectInactiveOfficesToRenewResponseModel) => {
        console.log("resp ", resp);
        resp.UserMessages.forEach(el => this.userMessages.push(el));
        this.currentPageWatcher.sendUserMessages(this.userMessages);

        let stepsList : Array<WorkflowStepModel> = [];

        if (resp.Summary == 0) {
          this.entityRenewalService.renewalWorkflowModel = resp.Workflow;
          this.entityRenewalService.renewalWorkflowModel.Steps.forEach(el=>{
            let step = this.storage.getStartFunctionData().Workflow.Steps.find(i => i.WorkflowStepType===el.WorkflowStepType)
            if(step){
              el.checked = step.checked;
            }
            else{
              el.checked=false;
  
            }
  
            stepsList.push(el);
          });

          this.startFunction.Workflow.Steps = stepsList;
          this.startFunction.Workflow.CurrentStepIndex = (this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex ? this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex : null);
          this.startFunction.Workflow.WorkflowID = (this.entityRenewalService.renewalWorkflowModel.WorkflowID ? this.entityRenewalService.renewalWorkflowModel.WorkflowID : null);
          this.startFunction.Workflow.WorkflowDisplayName = (this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName ? this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName : null);
          this.startFunction.Workflow.Fees = (this.entityRenewalService.renewalWorkflowModel.Fees ? this.entityRenewalService.renewalWorkflowModel.Fees : null);
          this.storage.setStartFunctionData(this.startFunction);

          if ((this.workflow.Steps[resp.Workflow.CurrentStepIndex]).StepDisplayName.toLowerCase().includes("questionnaire")) {
            this.router.navigate(["/entityRenewalQuestionnaire"]).then(() => {
              //add emitters for selected elements in Inactive Offices
              this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
              this.startFunctionService.getNotifyStepInProgress().emit(true);
              this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(resp);
              this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
              this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
              this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);

            });
            this.userMessages = [];
          }

          if ((this.workflow.Steps[resp.Workflow.CurrentStepIndex]).StepDisplayName.toLowerCase().includes("review")) {
            //redirect to review
            this.router.navigate(["/reviewEntityRenewal"]).then(() => {
              this.startFunctionService.getNotifyStepInProgress().emit(true);
              this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(resp);
              this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
              this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
            })
            this.userMessages = [];
          }
        }
        if (resp.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (resp.Summary == 2) {
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      })



  }

  selectAll() {
    for (var i = 0; i < this.officeList.length; i++) {
      if (this.officeList[i].IsSelectable) {
        this.officeList[i].selected = this.selectedAll;
      }
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.officeList.every(function (item: any) {
      return item.selected == true;
    })
  }

  goBack(){
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
    let currentStep =  this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 52)[0]) != -1 ? this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 52)[0]) : this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 39)[0]);

    //previous step = start entity renewal (WorkflowStepType : 23 ; path: /startEntityRenewal) 
    if(this.workflow.Steps[currentStep - 1].WorkflowStepType == 23){
      this.router.navigate(["/startEntityRenewal"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
      })
    }

    //previous step = individual-corporation-status (WorkflowStepType : 50 ; path: /individualCorporation) 
    if(this.workflow.Steps[currentStep - 1].WorkflowStepType == 50){
      this.router.navigate(["/individualCorporation"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      })
    }

    //previous step = individual-verify-questionnaire (WorkflowStepType : 18 ; path: /verifyIndividualRenewalQuestionnaire) 
    if(this.workflow.Steps[currentStep - 1].WorkflowStepType == 18){
      this.router.navigate(["/verifyIndividualRenewalQuestionnaire"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      })
    }
  }
  
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
   this.goBack();
  }

  ngOnDestroy(): void {
    //this.currentPageWatcher.sendUserMessages(null);
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
}



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/inactive-offices-entity-renewal/inactive-offices-entity-renewal.component.ts